import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    const navLinkClass = ({ isActive }) =>
        `menuitems ${isActive ? "active-menu" : ""}`;

    return (
        <>
            {/* =========================
                MAIN HEADER / MENU
            ========================== */}
            <header className="main-header">

                <div className="header-inner">

                    {/* =========================
                        LOGO + TEMPLE NAME
                    ========================== */}
                    <div className="logo-section">

                        <NavLink to="/" onClick={closeMenu}>
                            <img
                                src="./images/devi-logo.png"
                                className="temple-logo"
                                alt="Sri Ayyappan Guruvayurappan Temple"
                            />
                        </NavLink>

                        <div className="temple-title">
                            <span>
                                Sri Ayyappan Guruvayurappan Temple <br /> Egmore, Chennai
                            </span>
                        </div>

                    </div>


                    {/* =========================
                        MOBILE HAMBURGER
                    ========================== */}
                    <button
                        type="button"
                        className="mobile-menu-button"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle navigation menu"
                        aria-expanded={menuOpen}
                    >
                        {menuOpen ? "✕" : "☰"}
                    </button>


                    {/* =========================
                        NAVIGATION
                    ========================== */}
                    <nav
                        className={`navigation ${
                            menuOpen ? "navigation-open" : ""
                        }`}
                    >

                        <div className="menu-list">

                            <NavLink
                                to="/"
                                className={navLinkClass}
                                onClick={closeMenu}
                                end
                            >
                                Home
                            </NavLink>

                            <NavLink
                                to="/History"
                                className={navLinkClass}
                                onClick={closeMenu}
                            >
                                History
                            </NavLink>

                            <a
                                href="https://booking.egmoreayyappantempleapms.in/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>

                            <NavLink
                                to="/timing"
                                className={navLinkClass}
                                onClick={closeMenu}
                            >
                                Darsan Time
                            </NavLink>

                            <NavLink
                                to="/administration"
                                className={navLinkClass}
                                onClick={closeMenu}
                            >
                                Administration
                            </NavLink>

                            <NavLink
                                to="/gallery"
                                className={navLinkClass}
                                onClick={closeMenu}
                            >
                                Gallery
                            </NavLink>

                            <NavLink
                                to="/Contact"
                                className={navLinkClass}
                                onClick={closeMenu}
                            >
                                Contact
                            </NavLink>

                        </div>


                        {/* =========================
                            SOCIAL MEDIA
                        ========================== */}
                        <div className="social-links">

    {/* Facebook */}
    <a
        href="https://www.facebook.com/share/p/19hV726Vqh/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        className="social-icon facebook"
    >
        <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <path
                fill="currentColor"
                d="M14 8h3V4h-3c-3.3 0-5 1.7-5 5v3H6v4h3v8h4v-8h3l1-4h-4V9c0-.7.3-1 1-1z"
            />
        </svg>
    </a>


    {/* Instagram */}
    <a
        href="https://www.instagram.com/egmore_ayyappan_temple?stkn=MWU4aTN2Y3Y3M2tyYw=="
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className="social-icon instagram"
    >
        <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="5"
                ry="5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            />

            <circle
                cx="12"
                cy="12"
                r="4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            />

            <circle
                cx="17.5"
                cy="6.5"
                r="1.2"
                fill="currentColor"
            />
        </svg>
    </a>

</div>


                    </nav>

                </div>

            </header>


            {/* =========================
                FLOATING ONLINE BOOKING
            ========================== */}
            <div className="floating-booking">

                <a
                    href="https://booking.egmoreayyappantempleapms.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="./images/online-booking.png"
                        alt="Online Booking"
                    />
                </a>

            </div>


            {/* =========================
                RESPONSIVE CSS
            ========================== */}
            <style>
                {`

                /* =====================================
                   MAIN HEADER
                ====================================== */

                .main-header {
                    width: 100%;
                    background: #ffffffde;
                    position: relative;
                    z-index: 999;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                }

                .header-inner {
                    width: 100%;
                    min-height: 90px;
                    display: flex;
                    align-items: center;
                    padding: 0 4%;
                }


                /* =====================================
                   LOGO
                ====================================== */

                .logo-section {
                    display: flex;
                    align-items: center;
                    flex: 0 0 auto;
                    min-width: 330px;
                }

                .logo-section a {
                    display: flex;
                    align-items: center;
                    text-decoration: none;
                }

                .temple-logo {
                    width: 75px;
                    height: 75px;
                    object-fit: contain;
                    display: block;
                }

                .temple-title {
                    padding-left: 12px;
                    line-height: 1.25;
                }

                .temple-title span {
                    font-size: 20px;
                    font-weight: 600;
                    color: #7b1e0b;
                    white-space: nowrap;
                }


                /* =====================================
                   NAVIGATION
                ====================================== */

                .navigation {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    gap: 15px;
                }

                .menu-list {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex-wrap: wrap;
                    gap: 4px;
                }

                .menuitems {
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;

                    padding: 10px 12px;

                    color: #4a4a4a;
                    text-decoration: none;

                    font-size: 15px;
                    font-weight: 500;

                    white-space: nowrap;

                    transition:
                        color 0.2s ease,
                        background-color 0.2s ease;
                }

                .menuitems:hover {
                    color: #d17a00;
                    text-decoration: none;
                }


                /* =====================================
                   ACTIVE MENU
                ====================================== */

                .menuitems.active-menu {
                    color: #d17a00;
                    font-weight: 700;
                }

                .menuitems.active-menu::after {
                    content: "";
                    position: absolute;

                    left: 12px;
                    right: 12px;
                    bottom: 2px;

                    height: 3px;

                    background: #d17a00;
                    border-radius: 5px;
                }


                /* =====================================
                   SOCIAL MEDIA
                ====================================== */

                .social-links {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 5px;
}

.social-icon {
    width: 38px;
    height: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    color: #ffffff;

    text-decoration: none;

    transition:
        transform 0.2s ease,
        opacity 0.2s ease;
}

.social-icon svg {
    width: 20px;
    height: 20px;
    display: block;
}

.social-icon:hover {
    color: #ffffff;
    transform: translateY(-2px);
    opacity: 0.85;
}

.social-icon.facebook {
    background: #1877f2;
}

.social-icon.instagram {
    background: linear-gradient(
        45deg,
        #feda75,
        #fa7e1e,
        #d62976,
        #962fbf,
        #4f5bd5
    );
}


                /* =====================================
                   MOBILE BUTTON
                ====================================== */

                .mobile-menu-button {
                    display: none;

                    width: 44px;
                    height: 44px;

                    border: 1px solid #d17a00;
                    border-radius: 6px;

                    background: #ffffff;
                    color: #d17a00;

                    font-size: 24px;

                    cursor: pointer;

                    align-items: center;
                    justify-content: center;
                }

                .mobile-menu-button:hover {
                    background: #d17a00;
                    color: #ffffff;
                }


                /* =====================================
                   FLOATING BOOKING
                ====================================== */

                .floating-booking {
                    position: fixed;

                    right: 30px;
                    bottom: 130px;

                    width: 130px;

                    z-index: 998;
                }

                .floating-booking a {
                    display: block;
                }

                .floating-booking img {
                    width: 100%;
                    height: auto;

                    display: block;

                    border: 4px solid #ffffff;
                    border-radius: 10px;

                    box-shadow:
                        0 5px 18px rgba(0,0,0,0.25);

                    transition:
                        transform 0.2s ease;
                }

                .floating-booking img:hover {
                    transform: scale(1.05);
                }


                /* =====================================
                   TABLET
                ====================================== */

                @media (max-width: 1200px) {

                    .header-inner {
                        padding: 0 2%;
                    }

                    .logo-section {
                        min-width: 290px;
                    }

                    .temple-logo {
                        width: 65px;
                        height: 65px;
                    }

                    .temple-title span {
                        font-size: 17px;
                    }

                    .navigation {
                        gap: 5px;
                    }

                    .menuitems {
                        padding: 9px 8px;
                        font-size: 14px;
                    }

                    .social-icon {
                        width: 32px;
                        height: 32px;
                        font-size: 15px;
                    }

                }


                /* =====================================
                   SMALL TABLET / MOBILE
                ====================================== */

                @media (max-width: 991px) {

                    .header-inner {
                        min-height: 75px;
                        padding: 0 20px;

                        justify-content: space-between;
                    }

                    .logo-section {
                        min-width: 0;
                        flex: 1;
                    }

                    .temple-logo {
                        width: 60px;
                        height: 60px;
                    }

                    .temple-title {
                        padding-left: 8px;
                    }

                    .temple-title span {
                        font-size: 17px;
                        white-space: normal;
                    }


                    /* Show hamburger */

                    .mobile-menu-button {
                        display: flex;
                        flex-shrink: 0;
                    }


                    /* Mobile navigation */

                    .navigation {
                        position: absolute;

                        top: 100%;
                        left: 0;
                        right: 0;

                        width: 100%;

                        background: #ffffff;

                        display: none;

                        flex-direction: column;
                        align-items: stretch;

                        padding: 10px 20px 20px;

                        box-shadow:
                            0 8px 15px rgba(0,0,0,0.12);
                    }

                    .navigation-open {
                        display: flex;
                    }

                    .menu-list {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;

                        width: 100%;
                        gap: 0;
                    }

                    .menuitems {
                        width: 100%;

                        justify-content: flex-start;

                        padding: 13px 15px;

                        font-size: 16px;

                        border-bottom: 1px solid #eeeeee;
                    }

                    .menuitems.active-menu {
                        background: #fff7e8;
                        color: #d17a00;
                    }

                    .menuitems.active-menu::after {
                        left: 5px;
                        right: auto;

                        top: 10px;
                        bottom: 10px;

                        width: 4px;
                        height: auto;
                    }


                    /* Social media */

                    .social-links {
                        width: 100%;

                        justify-content: center;

                        margin: 15px 0 0;

                        padding-top: 15px;

                        border-top: 1px solid #eeeeee;
                    }

                    .social-icon {
                        width: 42px;
                        height: 42px;

                        font-size: 18px;
                    }


                    /* Floating booking */

                    .floating-booking {
                        right: 20px;
                        bottom: 30px;
                        width: 100px;
                    }

                }


                /* =====================================
                   MOBILE
                ====================================== */

                @media (max-width: 575px) {

                    .header-inner {
                        min-height: 68px;
                        padding: 0 12px;
                    }

                    .temple-logo {
                        width: 52px;
                        height: 52px;
                    }

                    .temple-title {
                        padding-left: 7px;
                    }

                    .temple-title span {
                        font-size: 14px;
                        line-height: 1.2;
                    }

                    .mobile-menu-button {
                        width: 40px;
                        height: 40px;

                        font-size: 21px;
                    }

                    .navigation {
                        padding-left: 12px;
                        padding-right: 12px;
                    }

                    .floating-booking {
                        right: 12px;
                        bottom: 20px;
                        width: 85px;
                    }

                }


                /* =====================================
                   VERY SMALL PHONES
                ====================================== */

                @media (max-width: 380px) {

                    .temple-logo {
                        width: 45px;
                        height: 45px;
                    }

                    .temple-title span {
                        font-size: 12px;
                    }

                    .mobile-menu-button {
                        width: 36px;
                        height: 36px;
                        font-size: 19px;
                    }

                }

                `}
            </style>
        </>
    );
}

export default MainMenu;
